import React from 'react';
import Icon from '../AppIcon';

const Button = ({
  children,
  variant = 'default',
  size = 'default',
  iconName,
  iconPosition = 'left',
  className = '',
  disabled = false,
  fullWidth = false,
  loading = false,
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-lg transition-smooth touch-feedback disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variantClasses = {
    default: 'bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/90',
    outline: 'border-2 border-border bg-transparent hover:bg-muted',
    ghost: 'hover:bg-muted',
    destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90 shadow-sm',
  };

  const sizeClasses = {
    sm: 'touch-target px-3 py-2 text-sm gap-1.5',
    default: 'touch-target px-4 py-2.5 text-base gap-2',
    lg: 'touch-target-lg px-6 py-3 text-base gap-2.5 sm:text-lg',
    xl: 'touch-target-xl px-8 py-4 text-lg gap-3',
  };

  const widthClass = fullWidth ? 'w-full' : '';

  const buttonClasses = `
    ${baseClasses}
    ${variantClasses?.[variant]}
    ${sizeClasses?.[size]}
    ${widthClass}
    ${className}
  `;

  return (
    <button
      className={buttonClasses}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current" />
      )}
      {!loading && iconName && iconPosition === 'left' && (
        <Icon name={iconName} size={size === 'sm' ? 16 : size === 'lg' || size === 'xl' ? 20 : 18} />
      )}
      {children}
      {!loading && iconName && iconPosition === 'right' && (
        <Icon name={iconName} size={size === 'sm' ? 16 : size === 'lg' || size === 'xl' ? 20 : 18} />
      )}
    </button>
  );
};

export default Button;